/**
 * Приводит номер из API/хранилища к виду для отображения и для поля с маской
 * (формат +7 (9XX) XXX-XX-XX, как в PHONE_CONSTRAINTS.MASK).
 */
export const formatPhoneMasked = (phoneNumber: string): string => {
	const clearedNumber = phoneNumber.replace(/\D/g, '')
	if (!clearedNumber) return ''

	const firstNumber = clearedNumber.substring(0, 1)
	const numberWithoutRegion =
		firstNumber === '8' || firstNumber === '7'
			? `(${clearedNumber.substring(1, 4)}) ${clearedNumber.substring(4, 7)}-${clearedNumber.substring(
					7,
					9
			  )}-${clearedNumber.substring(9, 11)}`
			: `(${firstNumber.substring(0, 3)}) ${clearedNumber.substring(3, 6)}-${clearedNumber.substring(
					6,
					8
			  )}-${clearedNumber.substring(8, 10)}`

	return `+7 ${numberWithoutRegion}`
}
